import React, {useState, useEffect} from 'react';
import {
  IonInput, IonList, IonLabel, IonItem,
  IonIcon, IonModal,
} from "@ionic/react";
import {InputProps} from "components/forms/Input";
import {searchOutline} from "ionicons/icons";
import {usePrevious} from "../lib/hooks";
import styles from './SearchInput.module.css';
import classNames from "classnames";
import SectionEmptyState from './SectionEmptyState';


interface SearchInputProps extends InputProps {
  collection: any[];
  labelField: string;
  valueField: string;
  getOptionLabel?: (instance: any) => React.ReactElement;
}

const getSelected = (collection: any[], value:any, labelField:string, valueField:string): string => {
  const selected: any = collection.find(i => {
    if (!value)
      return false;
    if (typeof value === 'object')
      return i[valueField] === value[valueField];
    return i[valueField] === value;
  });

  if (selected)
    return labelField ? selected[labelField] : selected;

  return '';
}

const SearchInput: React.FC<SearchInputProps> = (props) => {
  const {collection, state, labelField, valueField, onChange, getOptionLabel} = props;
  const {value} = state;
  const [isOpen, setIsOpen] = useState(false);
  const [filteredCollection, setFilteredCollection] = useState<any[]>([...collection]);
  const [searchInput, setSearchInput] = useState('');
  const [label, setLabel] = useState(value);
  const wasOpen = usePrevious(isOpen);
  const previousValue = usePrevious(value);

  const interfaceOptions = props.interfaceOptions || "app-select-alert";

  // abrindo
  useEffect(() => {
    if (isOpen && !wasOpen) {
      // validation
      if (!labelField)
        throw Error("Undefinied labelField for SearchInput.");
      if (!valueField)
        throw Error("Undefinied valueField for SearchInput.");

      setSearchInput('');
      setFilteredCollection([...collection]);
    }
  }, [collection, isOpen, wasOpen, labelField, valueField]);

  // update label
  useEffect(() => {
    if (collection.length && value !== previousValue) {
      setLabel(getSelected(collection, value, labelField, valueField));
    }
  }, [collection, labelField, previousValue, value, valueField]);

  const onChangeTermo = (e:any) => {
    const termo = e.detail.value.toLowerCase();

    let filteredCollection: any[];
    if (termo)
      filteredCollection = collection!.filter(
        i => i[labelField!].toLowerCase().includes(termo));
    else
      filteredCollection = [...collection];

    setFilteredCollection(filteredCollection);
    setSearchInput(termo);
  };

  const onClickItem = (item:any) => {
    onChange(props.definition.name, item[valueField!]);
    setIsOpen(false);
  };

  return (
    <div className="search">
      <IonItem
        disabled={props.disabled}
        button={true}
        detail={false}
      >
        <IonLabel
          position={props.labelPosition || 'floating'}
        >
        <span className={(state.touched && state.hasError) ? "text-red-600" : ""}>
          {props.definition.label} {props.definition.required && '*'}
        </span>
        </IonLabel>

        <IonInput
          value={label}
          readonly={true}
        />
        <div className="flex flex-col justify-center h-full" slot="end">
          <IonIcon
            icon={searchOutline}
            slot="end"
          />
        </div>
        <button
          className="absolute left-0 top-0 w-full h-full cursor-pointer bg-transparent appearance-none outline-none"
          style={{zIndex: 9999999}}
          onClick={(e: any) => {
            e.stopPropagation();
            e.preventDefault();
            setIsOpen(true);
          }}
        />
      </IonItem>

      {/* Pop search */}
      <IonModal
        isOpen={isOpen}
        onDidDismiss={() => setIsOpen(false)}
        showBackdrop={true}
        className={classNames(styles.modal, interfaceOptions, "modal-as-alert")}
      >
        <div className="h-full overflow-y-hidden flex flex-col">
          <div>
            <IonItem>
              <IonInput
                placeholder="Procurar..."
                debounce={20}
                onIonChange={onChangeTermo}
              />
            </IonItem>
          </div>

          <div className={classNames("flex-grow overflow-y-auto", styles.listContainer)}>
            {filteredCollection.length && filteredCollection.length <= 150 ? (
              <IonList>
                {
                  filteredCollection && filteredCollection.map((i: any) => (
                    <IonItem
                      key={i[valueField]}
                      button={true}
                      detail={false}
                      onClick={() => onClickItem(i)}
                      lines="none"
                    >
                      {getOptionLabel ? getOptionLabel(i) :
                        <IonLabel>
                          {i[labelField]}
                        </IonLabel>
                      }
                    </IonItem>
                  ))
                }
              </IonList>
            ) : (
              <div>
                { searchInput ? (
                  <SectionEmptyState
                    text={'Nenhum item encontrado.'}
                  />
                ) : (
                  <SectionEmptyState
                    text={'Digite sua busca para selecionar.'}
                  />
                )
                }
              </div>
            )
            }
          </div>
        </div>
      </IonModal>
    </div>
  );
}

export default SearchInput;
